import { useRef, useState, useCallback, KeyboardEvent, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

function useInsightsSearch() {
  const navigate = useNavigate();
  const { state, pathname, hash } = useLocation();
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  const [searchParams] = useSearchParams();
  const [searchKeyword, setSearchKeyword] = useState(searchParams.get('search') || '');

  useEffect(() => {
    if (searchParams.get('search') && searchInputRef.current) {
      searchInputRef.current.value = searchParams.get('search') || '';
    }
  }, [searchInputRef]);

  const handleSearchKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter') {
        setSearchKeyword(event.currentTarget.value);
        searchParams.set('search', event.currentTarget.value);
        navigate(`${pathname}?${searchParams.toString()}${hash}`, {
          state,
          replace: true,
          preventScrollReset: true,
        });
      }
    },
    [pathname, searchParams],
  );

  const handleClearSearch = useCallback(() => {
    if (searchInputRef.current) {
      setSearchKeyword('');
      searchParams.delete('search');
      navigate(`${pathname}?${searchParams.toString()}${hash}`, {
        state,
        replace: true,
        preventScrollReset: true,
      });
      searchInputRef.current.value = '';
    }
  }, [searchInputRef, pathname, searchParams]);

  return {
    searchInputRef,
    searchKeyword,
    handleClearSearch,
    handleSearchKeyDown,
  };
}

export default useInsightsSearch;
